import {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  Box,
  Container,
  Flex,
  Heading,
  ListItem,
  OrderedList,
  SimpleGrid,
  Text,
  UnorderedList,
} from '@chakra-ui/react';
import React from 'react';
import Link from 'next/link';
import Image from 'next/image';

import ResourceLayout from '@/components/resources/ResourceLayout';
import PerformanceCard from '@/components/resources/PerformanceCard';

const ResourcesStatData = [
  {
    id: 1,
    title: 'Crisil AIF Benchmarks',
    desc: 'Crisil is the pioneer in benchmarks for the alternative investment funds (AIFs) industry in India. Our benchmarks cover all the three broad categories of AIFs – Category I, II and III – and provide investors with a metric to compare an AIF’s performance with the category…',
    imgSrc:
      'https://static.levocdn.com/WGLBUT82/CrisilSP-RGB-blackred-sR8fjbx3swhc.png',
    readLink:
      'https://www.crisil.com/en/home/what-we-do/financial-products/alternate-investment-funds-benchmarks.html',
    date: '',
  },
  {
    id: 2,
    title: 'NSE Indices Ltd - AIF Benchmarks',
    desc: 'The Nifty Alternative Investment Fund (AIF) Benchmark Report aims to provide the users insights into the aggregate historical performance of various categories of AIFs in India.  This report will help the investors in comparing historical performances of various AIFs with their respective benchmarks and',
    imgSrc: '/svg/nse.svg',
    readLink: 'https://www.nseindia.com/products-services/aif-benchmark-report',
    date: '',
  },
  {
    id: 3,
    title: 'Preqin - AIF Benchmarks',
    desc: 'Preqin is proud to launch our first dedicated performance benchmark for India’s Alternative Investment Funds (AIFs) in partnership with the Indian Venture and Alternate Capital Association (IVCA) and under eligibility from the Securities and Exchange Board of India (SEBI). The benchmark comprises 296 schemes across Category I, II, and III AIFs for performance data as of March 31, 2021.',
    imgSrc: '/png/preqin.png',
    readLink:
      'https://www.preqin.com/insights/research/factsheets/performance-benchmark-for-india-alternative-investment-funds-as-of-march-2023',
    date: '',
  },
];

const information = [
  {
    id: 1,
    title: 'Background',
    info_one:
      'The Alternative Investment Policy Advisory Committee (AIPAC) which was set up under the able leadership of Shri Narayana Murthy submitted its 2ndAIPAC committee report to the SEBI and the Ministry of Finance on 1st November 2016. This report deals in detail the need for performance benchmarking for AIFs in a country like India. Post the subsequent discussion & deliberations and tremendous contribution from the members the AIPAC committee as well as the working group members for benchmarking of AIFs under the aegis of SEBI, it has been possible to come to a stage where SEBI has put out a definitive circular on the applicability of the same. There was a greater call among the Industry to have more transparency in the Alternative Investment Funds universe which will greatly help instil confidence in the Investors and develop mutual trust. We have seen the Industry grow from Rs 0.31 lakh Cr. (USD 4.38 Bn) as of 31st Dec 2015 to Rs 4.51 lakh Cr. (USD 62.66 Bn) as of 31st March, 2021 in terms of the commitments raised. Kindly note that the numbers refer to only the SEBI registered AIFs portion of commitments raised and excludes all non AIF/Global funds operating in India. To achieve the objective of attracting large pools of long-term funds, the industry needs to equip itself in order to cater to the needs of the diverse set of investors it attracts. To fulfil this objective, three critical factors were identified:',
    list: [
      {
        id: 1,
        text: 'disclosure of relevant fund-level information to its investors',
        listing: [],
        link: '#',
      },
      {
        id: 2,
        text: 'enhanced fund-level governance and',
        listing: [],
        link: '#',
      },
      {
        id: 3,
        text: 'aggregate data on industry-level performance to inform and thereby attract current and potential investors',
        listing: [],
        link: '#',
      },
    ],
    info_two:
      'Keeping the above in mind, the Securities and Exchange Board of India (SEBI) issued a circular SEBI/HO/IMD/DF6/CIR/P/2020/24 dated 5th February 2020 on Disclosure standards of AIFs and read along with SEBI circular SEBI/HO/IMD/DF6/CIR/P/2020/99 dated 12 June 2020, wherein under it notified implementation of performance benchmarking for Alternative Investment Funds (AIFs) with effect from 1st October, 2020 and is mandatory for all AIFs.',
  },
  {
    id: 2,
    title: 'IVCA Role',
    info_one:
      'IVCA fulfils the criteria as mentioned in the circular and this is to inform you that SEBI has taken on record IVCA’s eligibility to appoint one or more benchmarking agencies to conduct performance benchmarking for Alternative Investment Funds (AIFs).',
    info_two:
      'To give brief backdrop, IVCA is the oldest and not for profit industry body in India having the highest representation of the PE & VC firms. It was established by industry professionals with a unified aim to drive forward India Private Equity (PE) & Venture Capital (VC) industry. Its purpose is to promote and support the Alternative Investment Asset class by facilitating advocacy discussion with the Government of India, policymakers, regulators, and supports the entrepreneurial activity, innovation and job creation in India.',
    list: [
      {
        text: 'About IVCA',
        link: '/about-us',
        listing: [],
      },
      {
        text: 'IVCA Membership Benefits',
        link: '/membership/member-benefits',
        listing: [],
      },
      {
        text: 'IVCA Membership Application Form',
        link: '/membership/membership-form',
        listing: [],
      },
      {
        text: 'List of IVCA Members',
        link: '/membership',
        listing: [],
      },
    ],
  },
  {
    id: 3,
    title: 'Benchmarking Details',
    info_one:
      'To this effect the AIF &the agency shall enter into a non-disclosure agreement. A standardized template has been finalized by each of the agency respectively for the sharing of data by AIFs for the purpose of benchmarking and will be communicated by the agency to AIFs by email. Please note IVCA does neither takes any responsibility nor involved in the process of data collection by the agencies and the confidentiality of the date.',
    list: [
      {
        text: 'Appointment of Benchmarking Agencies',
        link: '#',
        listing: [
          {
            text: 'Pursuant to the circulars and IVCA’s eligibility to appoint one or more benchmarking agencies, IVCA has initially appointed CRISIL Limited, a premiere rating agency in India and recently appointed Preqin Limited, a premiere data service provider and benchmarking agency for alternatives industry globally as the benchmarking agencies for conducting benchmarking of AIFsand NSE Indices Limited (100% subsidiary. And not 0.00 % of National Stock Exchange of India Ltd.), one of the foremost indices company in India. They provide a variety of indices and index related services for the capital markets. The company owns and manages a portfolio of indices under the NIFTY brand of NSE, including the flagship index, the NIFTY 50.',
          },
        ],
      },
      {
        text: 'Benchmarking Timeline',
        link: '#',
        listing: [
          {
            text: 'The first Industry benchmarks for CAT I, II & III respectively, have been launched by CRISIL on 1st October 2020, followed by NSE Indices on 14th March, 2022 and Preqin on 25th May, 2022.',
          },
          {
            text: 'Subsequent to the initial benchmarks put out which focused on each of the three categories on an aggregate basis and a few vintages from 2014 onwards where there is a minimum number of registered AIFs; all three agencies have now launched sub category benchmarks.',
          },
          {
            text: 'The benchmarking agencies are expected to declare Performance Benchmarks on a bi-annual basis on the data as of September 30th & March 31st every year.',
          },
        ],
      },
      {
        text: 'Reports',
        link: '#',
        listing: [
          {
            text: 'Every AIF which intends to raise funds in the country can obtain Performance Benchmarking Report from any of the three agencies at their option, the details of which can be included in its PPM and other marketing material.',
          },
          {
            text: 'In addition to the above, AIFs which are not raising any funds, but still wish to get a report from these agencies on performance of their schemes/ funds, they may also get a report.',
          },
          {
            text: 'The commercial considerations involved in procuring such benchmarking reports and usage of benchmarks shall be obtaineddirectly from the respective agencies',
          },
        ],
      },
      {
        text: 'Data Collection and NDA',
        link: '#',
        listing: [
          {
            text: 'The process of data collection is applicable for all AIFs/ Schemes of AIFs that are registered with SEBI, which shall be required to provide all the necessary information/data to these agencies as may be sought by it.',
          },
        ],
      },
    ],
  },
  {
    id: 4,
    title: 'SEBI Circulars',
    list: [
      {
        text: 'SEBI Circular dated 5 February 2020 - ',
        link: 'https://static.levocdn.com/WGLBUT82/6994598928890771420.pdf',
        listing: [],
      },
      {
        text: 'SEBI Circular dated 12 June 2020 - ',
        link: 'https://static.levocdn.com/WGLBUT82/6994598928844620240.pdf',
        listing: [],
      },
      {
        text: 'Operational Guidelines for implementation of Performance Benchmarking - ',
        link: 'https://static.levocdn.com/WGLBUT82/6994598928834972124.pdf',
        listing: [],
      },
    ],
  },
  {
    id: 5,
    title: 'IVCA Communication to Members',
    list: [
      {
        text: 'Request for Timely Submission of Performance Benchmarking Data by IVCA Member AIFs: 28 Feb, 2023',
        link: 'https://static.levocdn.com/WGLBUT82/7042010404745085409.pdf',
        listing: [],
      },
      {
        text: 'Update on Performance Benchmarking Agencies - Uniform data collating template: 27 Sep, 2022',
        link: 'https://static.levocdn.com/WGLBUT82/7042010243293235044.pdf',
        listing: [],
      },
      {
        text: 'Appointing additional agencies for Performance Benchmarking of AIFs - Preqin Limited and NSE Indices Limited: 7 Sep, 2021',
        link: 'https://static.levocdn.com/WGLBUT82/7042009232990177932.pdf',
        listing: [],
      },
      {
        text: 'SEBI mandates Performance Benchmarking and all AIFs to provide the necessary information-data to the Benchmarking Agency: 4 Aug, 2020',
        link: 'https://static.levocdn.com/WGLBUT82/7042009051070870471.pdf',
        listing: [],
      },
    ],
  },
];

const PerformanceBenchmark = () => (
  <Flex flexDir="column">
    <Box bg="lightWhite">
      <Box
        maxW="900px"
        mx="auto"
        mb={{ xs: '40px', sm: '80px', md: '120px', lg: '150px' }}
        mt={{ xs: '50px', sm: '70px', md: '90px', lg: '70px' }}
      >
        <Heading mb="15px" textAlign="center" px={{ xs: '15px', sm: '10px' }}>
          Circular Issued by SEBI
        </Heading>
        <Text textAlign="center" px={{ xs: '20px', sm: '15px' }}>
          The Securities and Exchange Board of India (SEBI) after deliberations
          on the recommendations of Alternative Investment Policy Advisory
          Committee (AIPAC) and Indian Private Equity and Venture Capital
          Association (IVCA) on the aspect of Performance Benchmarking for the
          Alternative Investments Industry, issued a circular on this matter.
        </Text>

        {/* Accordion */}
        <Accordion pt="46px" px="20px" allowToggle>
          {information.map((info) => (
            <AccordionItem key={info.id}>
              {({ isExpanded }) => (
                <>
                  <Text py="24px">
                    <AccordionButton _hover={{ bg: 'none' }}>
                      <Flex flex="1" textAlign="left">
                        <Text
                          variant="infoText"
                          color={isExpanded ? 'text.green' : 'text.textBlue'}
                          pr="20px"
                        >
                          {info.title}
                        </Text>
                      </Flex>
                      {isExpanded ? (
                        <Image
                          src="/svg/minus.svg"
                          alt="minus"
                          width={13}
                          height={13}
                        />
                      ) : (
                        <Image
                          src="/svg/Plus.svg"
                          alt="plus"
                          width={13}
                          height={13}
                        />
                      )}
                    </AccordionButton>
                  </Text>
                  <AccordionPanel pb={4}>
                    {info.id === 1 && (
                      <>
                        <Text variant="disclaimerText">{info.info_one}</Text>
                        <OrderedList>
                          {info.list?.map((item) => (
                            <ListItem
                              fontWeight="400"
                              fontSize="15px"
                              color="text.mediumBlackAlpha"
                              my="12px"
                            >
                              {item.text}
                            </ListItem>
                          ))}
                        </OrderedList>
                        <Text variant="disclaimerText">{info.info_two}</Text>
                      </>
                    )}
                    {info.id === 2 && (
                      <>
                        <Text
                          fontWeight="400"
                          fontSize="16px"
                          color="text.textBlue"
                          textAlign="justify"
                        >
                          {info.info_one}
                        </Text>
                        <Text
                          fontWeight="400"
                          fontSize="16px"
                          color="text.textBlue"
                          textAlign="justify"
                        >
                          {info.info_two}
                        </Text>
                        <Text
                          fontWeight="600"
                          fontSize="17px"
                          color="text.greyPurple"
                          my="10px"
                        >
                          Read more about IVCA:
                        </Text>
                        <UnorderedList>
                          {info.list.map((item) => (
                            <ListItem my="12px">
                              <Text
                                fontWeight="400"
                                fontSize="16px"
                                color="text.textBlue"
                                as="span"
                              >
                                {item.text}
                              </Text>
                              <Link
                                aria-label={item.text}
                                href={item.link}
                                passHref
                              >
                                <Text
                                  as="span"
                                  color="primary.500"
                                  _hover={{
                                    textDecoration: 'underline',
                                    cursor: 'pointer',
                                  }}
                                >
                                  &nbsp;-&nbsp;CLICK HERE
                                </Text>
                              </Link>
                            </ListItem>
                          ))}
                        </UnorderedList>
                      </>
                    )}
                    {info.id === 3 && (
                      <>
                        {info.list.map((item, index) => (
                          <Flex
                            my="15px"
                            mb="16px"
                            columnGap="10px"
                            flexDir="column"
                          >
                            <Flex>
                              <Text as="span" fontSize="17px" fontWeight="700">
                                {index + 1}.&nbsp;
                              </Text>
                              <Text as="span" fontSize="17px" fontWeight="700">
                                {item.text}
                              </Text>
                            </Flex>
                            {item.listing.map((subItem: { text: string }) => (
                              <UnorderedList my="10px" pl="16px">
                                <ListItem
                                  fontSize="15px"
                                  fontWeight="400"
                                  color="text.mediumBlackAlpha"
                                  textAlign="justify"
                                >
                                  {subItem.text}
                                </ListItem>
                              </UnorderedList>
                            ))}
                          </Flex>
                        ))}
                        <Text variant="disclaimerText">{info.info_one}</Text>
                      </>
                    )}
                    {(info.id === 4 || info.id === 5) && (
                      <UnorderedList>
                        {info.list?.map((item) => (
                          <ListItem my="12px">
                            <Text variant="disclaimerText" as="span">
                              {item.text}
                            </Text>
                            <Link
                              aria-label={item.text}
                              href={item.link}
                              target="_blank"
                            >
                              <Text
                                color="primary.500"
                                _hover={{
                                  textDecoration: 'underline',
                                  cursor: 'pointer',
                                }}
                              >
                                CLICK HERE
                              </Text>
                            </Link>
                          </ListItem>
                        ))}
                      </UnorderedList>
                    )}
                  </AccordionPanel>
                </>
              )}
            </AccordionItem>
          ))}
        </Accordion>
      </Box>
    </Box>
    <Flex
      flexDir="column"
      margin="0 auto"
      borderBottom="1px solid rgba(100, 100, 140, 0.16)"
      width="100%"
      alignItems="center"
      pb={{ xs: '0px', sm: '40px' }}
    >
      <ResourceLayout
        heading="Performance Benchmarking of AIFs"
        desc=""
        onInputChange={() => {}}
      />
    </Flex>
    <Container maxW="1100px" pb={{ xs: '40px', sm: '80px', md: '100px' }}>
      <SimpleGrid
        pt={{ xs: '40px', sm: '50px' }}
        w="100%"
        gap="31px"
        columns={{ xs: 1, md: 2 }}
        justifyItems="center"
      >
        {ResourcesStatData.map((stat) => (
          <PerformanceCard
            key={stat.id}
            imgSrc={stat.imgSrc}
            title={stat.title}
            desc={stat.desc}
            date={stat.date}
            type="performance"
            readLink={stat.readLink}
          />
        ))}
      </SimpleGrid>
    </Container>
  </Flex>
);

export default PerformanceBenchmark;
